import { gutterCalculator } from "../../../util/utils";
import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../../styles/cssinjs/helpers/variables.js";

type Item = {
  icon: string;
  title: string;
  dot: {
    color: string;
  };
  href: string;
};

type ListProps = {
  data: Item[];
  classes: string;
};

const List = ({ data, classes }: ListProps) => {
  return (
    <div className={`container card--default card--feature fx--tl ${classes}`}>
      {data.map((item, count) => {
        return (
          <div
            key={count}
            className={`btn-outline md:mb-0 pt-3 pb-4 px-3 text-left bg:hover-white highlight-card  
             ${gutterCalculator("gutter-space", count)}  ${
              count >= 3 ? "lg:mt-5" : ""
            } ${count > 0 ? "md:mt-2.5" : ""}`}
          >
            <div className="icon-title-wrap">
              {item.hasOwnProperty("icon") && (
                <figure dangerouslySetInnerHTML={{ __html: item.icon }} />
              )}
              <h3 className="lg:mt-2 has-line --blue">{item.title}</h3>
              {item.hasOwnProperty("dot") && (
                <span className={`animated-dot ${item.dot.color}`} />
              )}
              <div className="wrap">
                <div className="action-trigger">
                  <a className="action-trigger__label" href={item.href}>
                    Read now
                  </a>
                </div>
              </div>
            </div>
            <style global jsx>
              {`
                .highlight-card h3 {
                  min-height: 130px !important;
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                }

                .wrap {
                  position: relative;
                  width: 80px;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  align-items: center;
                }

                .action-trigger {
                  display: block;
                  position: relative;
                  padding: 0 0.25rem;
                }

                .action-trigger__label {
                  display: inline-block;
                  font-size: 1rem;
                  line-height: 1;
                  font-weight: 700;
                  letter-spacing: 0.25;
                  color: ${colors.derived.brand};
                  opacity: 0;
                  transform: translateY(20%);
                  transition: transform 0.4s cubic-bezier(0.5, 0, 0.1, 1),
                    color 0.4s cubic-bezier(0.5, 0, 0.1, 1),
                    opacity 0.4s cubic-bezier(0.5, 0, 0.1, 1);
                }

                .action-trigger::after {
                  content: "";
                  display: block;
                  position: absolute;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  height: 0.5rem;
                  background-color: ${colors.primitive.blue[200]};
                  border-radius: 4px;
                  transition: transform 0.4s cubic-bezier(0.5, 0, 0.1, 1),
                    background-color 0.4s cubic-bezier(0.5, 0, 0.1, 1);
                }

                .highlight-card:hover .action-trigger .action-trigger__label {
                  color: ${colors.primitive.blue[600]};
                  opacity: 1;
                  transform: translateY(0%);
                }

                .highlight-card:hover .action-trigger::after {
                  transform: translateY(100%) scaleY(0.25);
                  background-color: ${colors.primitive.blue[600]};
                }

                @media (min-width: ${viewport.tablet.md}) {
                  .gutter-space {
                    margin-left: 40px;
                    margin-right: 40px;
                  }
                }

                @media (min-width: ${viewport.tablet
                    .sm}) and (max-width: ${viewport.tablet.md}) {
                  .gutter-space {
                    margin-left: 20px;
                    margin-right: 20px;
                  }
                  .wrap {
                    position: absolute;
                    bottom: 28px;
                  }
                }

                @media (max-width: ${viewport.tablet.md}) {
                  .highlight-card h3 {
                    min-height: auto !important;
                    margin-bottom: 24px;
                  }
                  .card--default.card--feature .icon-title-wrap {
                    margin-bottom: 0px;
                    display: flex;
                    flex-direction: column;
                  }
                }
              `}
            </style>
          </div>
        );
      })}
    </div>
  );
};

type FeaturedCardProps = {
  data: Item[];
  classes: string;
};

const FeaturedCard = ({ data, classes }: FeaturedCardProps) => {
  return <List data={data} classes={classes} />;
};

export default FeaturedCard;
